import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { expanded, rotate } from '../../animations/animations';
import { IconComponent } from '../../icons/icon.component';
import { IconNameType } from '../../icons/icon-name-type.enum';

@Component({
  selector: 'cwo-offer-details',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, IconComponent],
  templateUrl: './offer-details.component.html',
  styleUrl: './offer-details.component.scss',
  animations: [expanded(), rotate('180deg')],
})
export class OfferDetailsComponent {
  details = input.required<string>();

  iconNameType = IconNameType;
  public collapsed = true;
}
